import React, { useEffect, useState } from 'react'
import { Link, useParams  } from "react-router-dom"
import './common.css'
import API_URL from '../common/Apiurl';

function Viewjob(){
    const apiUrl = API_URL;
    const [items, setItems] = useState({});
    const viewId = useParams();
    const jobId = viewId.jobid;

    useEffect(() => {
        const getComments = async () => {
          try{
            const postData = {
                jobid: jobId
            };
            const res = await fetch(`${apiUrl}/admin/viewjobAdmin`,{
                method:'POST',
                headers:{
                    "Content-Type":"application/json",
                    "Accept":"application/json"
                },
                body:JSON.stringify(postData)
            });
            const data = await res.json();
            if(data.status !== 200){
              throw new Error('Data not found');
            }
            console.log(data);
            setItems(data.data);
            // if(data.data.length>=2){
            //     // setItemstwo(data.data[1]);
            // }            
            // setValues(data.value);
          }catch(error){
            console.error('Error ', error)
          }
        };
        getComments();
      }, []);
      
      if(items?.feedback_creator && items.feedback_creator.length > 0){ 
        var creatorfeed = <div className="col-sm-10 mt-1">
                            <span className='display-block mt-2'>Communication: {items?.feedback_creator[0].communication}</span>
                            <span className='display-block mt-2'>Knowledge: {items?.feedback_creator[0].knowledge}</span>
                            <span className='display-block mt-2'>Transparency: {items.feedback_creator[0].transparency}</span>
                            <span className='display-block mt-2'>Cleanliness: {items.feedback_creator[0].cleanliness}</span>
                            <span className='display-block mt-2'>Professionalism: {items.feedback_creator[0].professionalism}</span>
                        </div>;
        var creatorfinal =  <span>{items.feedback_creator[0].feedback}</span>;      
        var creatorInfo = <div className="col-sm-10 mt-1">
        <span className='d-block'>{items.feedback_creator[0].name}</span>
        <span className='d-block'>{items.feedback_creator[0].email}</span>
    </div>              
      }
      if(items?.feedback_provider && items.feedback_provider.length > 0){
        var providerfeed= <div className="col-sm-10 mt-1">
                            <span className='display-block mt-2'>Communication: {items.feedback_provider[0].communication}</span>
                            <span className='display-block mt-2'>Knowledge: {items.feedback_provider[0].knowledge}</span>
                            <span className='display-block mt-2'>Transparency: {items.feedback_provider[0].transparency}</span>
                            <span className='display-block mt-2'>Cleanliness: {items.feedback_provider[0].cleanliness}</span>
                            <span className='display-block mt-2'>Professionalism: {items.feedback_provider[0].professionalism}</span>
                        </div>;
        var providerfinal =  <span>{items.feedback_provider[0].feedback}</span>
        var providerInfo = <div className="col-sm-10 mt-1">
        <span className='d-block'>{items.feedback_provider[0].name}</span>
        <span className='d-block'>{items.feedback_provider[0].email}</span>
    </div>
    }
    return (
        <div className='width90'>
            <h2 className='pageTitle'>View Job Feedback</h2>
            <div className='commonCntr'>
                <form className="form-horizontal" action="">
                    <div className="form-group">
                        <label className="control-label col-sm-2 label">Job Title:</label>
                        <div className="col-sm-10 mt-1">
                            <span>{items.title}</span>
                        </div>
                    </div>
                    <div className="form-group mt-4">
                        <label className="control-label col-sm-2 label">Job Description:</label>
                        <div className="col-sm-10 mt-1">
                            <span>{items.description}</span> 
                        </div>
                    </div>
                    <div className="form-group mt-4">
                        <label className="control-label col-sm-2 label">Job Creator:</label>
                        {creatorInfo}
                    </div>
                    <div className="form-group mt-4">
                        <label className="control-label col-sm-2 label">Job Reviews</label>
                        {creatorfeed}
                    </div>
                    <div className="form-group mt-4">
                        <label className="control-label col-sm-2 label">Feedback</label>
                        <div className="col-sm-10 mt-1">
                            <span>{creatorfinal}</span>
                        </div>
                    </div>
                    <div className="form-group mt-4">
                        <label className="control-label col-sm-2 label">Job Assigned to:</label>
                        {providerInfo}
                    </div>
                    <div className="form-group mt-4">
                        <label className="control-label col-sm-2 label">Job Reviews</label>
                        {providerfeed}
                    </div>
                    {/* <div className="form-group mt-4">
                        <label className="control-label col-sm-2 label">Is job active?</label>
                        <div className="col-sm-10 mt-1">
                            <span>{active}</span>
                        </div>
                    </div>
                    <div className="form-group mt-4">
                        <label className="control-label col-sm-2 label">Is job completed?</label>
                        <div className="col-sm-10 mt-1">
                            <span>{completed}</span>
                        </div>
                    </div> */}
                    <div className="form-group mt-4">
                        <label className="control-label col-sm-2 label">Feedback</label>
                        <div className="col-sm-10 mt-1">
                            <span>{providerfinal}</span>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    )
}

export default Viewjob;